import { convertRestIdToEwsId } from 'owa-identifiers';
import { convertToItemIds } from './converterHelpers';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SearchResultItemId } from 'mini-3s-service/lib/schema/SubstrateSearchResponse';

/**
 * If feature-flag for immutableId is present, returns immutableId as the first index of array,
 * else returns ItemIds from search.
 * @param immutableId
 * @param itemIds
 * @returns
 */
export const getAppropriateItemIds = (immutableId: string, itemIds: SearchResultItemId[]) =>
    isFeatureEnabled('fwk-immutable-ids')
        ? convertToItemIds([{ Id: convertRestIdToEwsId(immutableId) }])
        : convertToItemIds(itemIds);
